import { setUserToken, resetUser } from "./user";
import { reqLogin } from "@/api/login";
import { saveToken, saveUser, clearLocalDatas, USER_INFO, TOKEN } from "@/utils/auth";

// 登录action
export const login = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    reqLogin(data)
      .then((response) => {
        if (response.status === 0) {
          const token = response.token;
          const userData = response.data;
          
          // 保存token到localStorage
          saveToken(token);
          
          // 保存用户信息到localStorage
          saveUser(JSON.stringify(userData));
          
          // 更新Redux状态
          dispatch(setUserToken(token));
          
          resolve(response);
        } else {
          const msg = response.message || "登录失败";
          reject(msg);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 登出action
export const logout = () => (dispatch) => {
  // 重置用户状态
  dispatch(resetUser());
  
  // 清除本地存储
  clearLocalDatas([USER_INFO, TOKEN]);
  
  return {
    status: 0,
    data: "success",
  };
};
